<template>
  <AppHome>
    <AppHeader
      slot="header"
      :actions="['exit']"
      tall
    />
    <div slot="main" class="home-balancer__main">
      <img v-if="fidmarques" src="~assets/images/fidmarques/fidmarques.png">
      <LoaderDualRings
        :total-size="6"
        :internal-ring-size="3"
        :internal-ring-color="fidmarques ? paletteFidmarques.orange : globalPrimaryColor"
        :external-ring-size="4"
        :external-ring-color="fidmarques ? paletteFidmarques.orangeLight : globalPrimaryColor"
      />
    </div>
  </AppHome>
</template>

<script>
import AppHome   from '~/components/layout/Home'
import AppHeader from '~/components/layout/Header'
import LoaderDualRings from '~/components/loaders/DualRings'

import MixinPaletteFidmarques from '~/mixins/paletteFidmarques'
import MixinPrimaryColor from '~/mixins/primaryColor'

export default {
  components: { AppHome, AppHeader, LoaderDualRings },
  mixins: [MixinPaletteFidmarques, MixinPrimaryColor],
  props: {
    fidmarques: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.home-balancer__main {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  text-align: center;
}
</style>
